import { Action, Module, VuexModule } from "vuex-module-decorators";
import { EmployeeStatus } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class EmployeeStatusModule extends VuexModule {
    @Action
    [EmployeeStatus.getEmployeeStatusList]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.get(`/status/employees/list`)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [EmployeeStatus.findPageEmployeeStatus](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/status/employees`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [EmployeeStatus.saveEmployeeStatus](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/status/employees/save`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

        @Action
    [EmployeeStatus.deleteEmployeeStatus](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/status/employees/delete`, values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}